import { useEffect } from 'react';
import { useMap } from 'rwl-ui';

export const useDisableMapControls = () => {
    const { map, isInitialized } = useMap();

    useEffect(() => {
        if (map && isInitialized) {
            map.setOptions({
                zoomControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                mapTypeControl: false,
                rotateControl: false,
                scaleControl: false,
                panControl: false,
                gestureHandling: 'none',
            });
        }
    }, [map, isInitialized]);
};
